export default "__VITE_ASSET__DB$SZkPp__"